module.exports = __webpack_public_path__ + "static/media/shutdown-illustration.452c875f.png";